const $ = window.$;
const moment = window.moment;

const todayReleaseDate = moment().format('YYYYMMDD');

function shouldTriggerDataLayerCallback(dataLayerName) {
  // trigger callback if dataLayerName is invalid, just to be sure
  if (typeof dataLayerName !== 'string') {
    return true;
  }

  // trigger callback if initiated by Google Tag Mangager
  if (dataLayerName.startsWith('GTM-')) {
    return true;
  }

  return false;
}

export function fixEETRelease(product) {
  if (product.dimension8 && product.dimension9 === 'Normal') {
    if (product.dimension8 === todayReleaseDate) {
      product.dimension9 = 'Release';
    }
  }
}

/*
export function clickTracking(product, list, callback) {
  if(!window.google_tag_manager) {
    callback();
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      click: {
        actionField: {list},
        products: [product],
      },
    },
    event: 'click',
    eventCallback: (dataLayerName) => {
      console.log(dataLayerName);

      if (shouldTriggerDataLayerCallback(dataLayerName)) {
        callback();
      }
    },
    eventTimeout: 2000,
  });
}
*/

export function productImpressionsTracking(products) {
  if (!products.length) {
    return;
  }
  products.map(fixEETRelease);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      currencyCode: 'EUR',
      impressions: products,
    },
    event: 'impressions',
  });
}

export function productDetailViewTracking(product) {
  const trackingData = { position: 0 };
  fixEETRelease(product);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      detail: {
        products: [$.extend({}, product, trackingData)],
      },
    },
    event: 'detail',
  });
}

export function purchaseTracking(purchase) {
  purchase.products.map(fixEETRelease);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      currencyCode: 'EUR',
      purchase,
    },
    event: 'purchase',
  });
}

export function cartViewTracking(products) {
  if (!products.length) {
    return;
  }
  products.map(fixEETRelease);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      currencyCode: 'EUR',
      cart: {
        products,
      },
    },
    event: 'cart',
  });
}


export function addToCartTracking(products, callback) {
  //console.log("addToCartTracking")

  if (!window.google_tag_manager) {
    callback();
    return;
  }

  if (!products.length) {
    callback();
    return;
  }
  products.map(fixEETRelease);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      currencyCode: 'EUR',
      add: {
        products,
      },
    },
    event: 'add',
    eventCallback: (dataLayerName) => {
      //console.log(dataLayerName);

      if (shouldTriggerDataLayerCallback(dataLayerName)) {
        callback();
      }
    },
    eventTimeout: 2000,
  });
}

export function removeFromCartTracking(products, callback) {
  //console.log("removeFromCartTracking")

  if (!window.google_tag_manager) {
    callback();
    return;
  }

  if (!products.length) {
    callback();
    return;
  }
  products.map(fixEETRelease);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      currencyCode: 'EUR',
      remove: {
        products,
      },
    },
    event: 'remove',
    eventCallback: (dataLayerName) => {
      //console.log(dataLayerName);

      if (shouldTriggerDataLayerCallback(dataLayerName)) {
        callback();
      }
    },
    eventTimeout: 2000,
  });
}
